module.exports = __webpack_public_path__ + "img/LCAGameDesignPage.f441f29b.jpg";